/**
 * The open part of an IELTS section (a Reading passage, a Listening part or a
 * Writing task), kept in this browser so a reload opens the same one. One entry
 * per attempt, for the open section only. Storage can be blocked (private mode,
 * full quota); the section then opens at its first part, as before.
 */
interface StoredSectionPart {
  sectionId: string;
  part: number;
}

const storageKey = (attemptId: string) => `examing.exam-part.${attemptId}`;

/** The saved part of this section, within `partCount`; 0 when there is none. */
export function loadSectionPart(attemptId: string, sectionId: string, partCount: number): number {
  try {
    const raw = localStorage.getItem(storageKey(attemptId));
    if (!raw || partCount < 1) return 0;
    const stored = JSON.parse(raw) as Partial<StoredSectionPart> | null;
    if (stored?.sectionId !== sectionId || !Number.isInteger(stored.part)) return 0;
    return Math.min(Math.max(stored.part as number, 0), partCount - 1);
  } catch {
    return 0;
  }
}

export function saveSectionPart(attemptId: string, sectionId: string, part: number): void {
  try {
    const stored: StoredSectionPart = { sectionId, part };
    localStorage.setItem(storageKey(attemptId), JSON.stringify(stored));
  } catch {
    // Storage blocked: see above.
  }
}

export function clearSectionPart(attemptId: string): void {
  try {
    localStorage.removeItem(storageKey(attemptId));
  } catch {
    // Storage blocked: see above.
  }
}
